import React from 'react'
import { Stack } from '@mui/material'
import GenerateByAiLoader from '../../../../animation/generate-ai-loader-animation/GenerateByAiLoader'
import styled from '@emotion/styled'
import { COLOR_MAP } from '../../../../constants/ColorNames'

const Container = styled(Stack)`
  padding: 8px 24px 8px 16px;
  gap: 9px;
  border-radius: 8px;
  background: #0C0A15;
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
`

const Message = styled.p`
  margin: 0;
  font-family: Noto Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: ${COLOR_MAP.WHITE}
`

const GeneratedByAiStrip = () => {
  return (
    <Container direction={'row'} alignItems={'center'}>
      <GenerateByAiLoader/>
    <Message>Your content is being generated by AI</Message>
    </Container>
  )
}

export default GeneratedByAiStrip
